module.exports = __webpack_public_path__ + "img/komarniki.2a3b534e.svg";